export function isInterventionStop(stop: { type?: string | null; ticketId?: string | null }): boolean {
  return stop.type === 'ticket' && !!stop.ticketId && stop.ticketId.startsWith('intervention-');
}
